
import folderA from "../assets/folder-a.svg";
import folderB from "../assets/folder-b.svg";
import folderFilled from "../assets/folder_filled.svg";
import analysisIcon from "../assets/files/analysis-icon.svg";

export const FOLDER_ICONS = [
    folderA,
    folderB,
    folderFilled,
    analysisIcon
];

export const getFolderIconByIndex = (index: number): string => {
    return FOLDER_ICONS[index] || FOLDER_ICONS[0]; // Default to first icon if index is invalid
};

export const getDefaultFolderIconIndex = (): number => {
    return 0; // Default to folder-a
};
